import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { UserContext } from "../context/UserContext";
import { useContext, useEffect, useMemo, useState, useRef } from "react";
import { base_url } from '../url_variables';
import axios from 'axios';
import { useCookies } from "react-cookie";
import { BarLoader, ClockLoader, GridLoader } from "react-spinners";
import { MenuContext } from "../context/MenuContext";
import { TbHistoryToggle, TbPigMoney } from "react-icons/tb";
import { BiMoneyWithdraw, BiSolidErrorAlt } from "react-icons/bi";
import { TopBar } from "../components/topbar";
import { IoIosSearch } from "react-icons/io";
import { FaPlaneArrival, FaPlaneDeparture, FaPlaneSlash, FaWhatsapp } from "react-icons/fa";
import { MdAirplanemodeActive, MdEmail } from "react-icons/md";
import { TostMessageContext } from "../context/TostMessage";
import { BellIcon, PinIcon, CloudOffIcon, AirportField, Icon, ToggleButton, FleetCard, Tab, ActionLink, StatusPill, PagerBtn, SectionTitle, Pill, CardShell, TextInput, DateInput } from "../components/icons";
import { FaPeopleGroup } from "react-icons/fa6";
import { CharterNote } from "../components/add_charter_note";

export default function FlightDetails() {
    const [cookies] = useCookies();
    const [loading, setLoading] = useState(false);
    const [buttonLoading, setButtonLoading] = useState(false);
    const navigate = useNavigate();
    const {setTostMessage, userProfile} = useContext(TostMessageContext);
    const [showModal, setShowModal] = useState(false);
    const {state} = useLocation();
    const {booking_reference, type} = useParams();
    const [pageData, setPageData] = useState({});
    const [passengers, setPassengers] = useState(
        pageData?.passengers || [
            { firstName: "", lastName: "", dob: "", passport: "" }
        ]
    );
    const [searchParams] = useSearchParams();

    const payment_status = searchParams.get("status");
    
    useEffect(() => {
        if (state?.row == undefined) {
            persistData();
        } else {
            setPageData(state?.row);
            setPassengers(state?.row?.passengers);
            persistData();
        }
    }, [])

    const persistData = async () => {
        const formData = new FormData();
        formData.append('type', type);
        formData.append('booking_reference', booking_reference);

        setButtonLoading(true)
        try {
            const response = await axios.post(base_url + '/my-flights/persist-data.php', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                },
            });
            if (response.data.status) {
                setPageData(response.data.data);
                setPassengers(response.data.data.passengers);
            } else {
                setTostMessage({
                    messageType: 'error',
                    message: response.data.message
                })
            }
            setButtonLoading(false)
        } catch (error) {
            setButtonLoading(false)
            setTostMessage({
                messageType: 'error',
                message: 'Network error'
            })
        }
    }
    
    const PayNGN = async (booking_reference) => {
        const formData = new FormData();
        formData.append('booking_reference', booking_reference);

        setButtonLoading(true)
        try {
            const response = await axios.post(base_url + '/make-payment/pay_charter_ngn.php', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                },
            });
            if (response.data.status) {
                setTostMessage({
                    messageType: 'success',
                    message: response.data.message
                })
                window.open(response.data.payment_link, "_self");
            } else {
                setTostMessage({
                    messageType: 'error',
                    message: response.data.message
                })
            }
            setButtonLoading(false)
        } catch (error) {
            setButtonLoading(false)
            setTostMessage({
                messageType: 'error',
                message: 'Network error'
            })
        }
    }

    const updatePassenger = (idx, patch) => {
        setPassengers((prev) => prev.map((p, i) => (i === idx ? { ...p, ...patch } : p)));
    };

    const addPassenger = () => {
        if (passengers?.length >= pageData?.seat_capacity) {
            setTostMessage({
                messageType: 'error',
                message: `There are only ${pageData?.seat_capacity} seat(s) left on this flight`
            })
            return;
        }
        setPassengers((prev) => [...prev, { firstName: "", lastName: "", dob: "", passport: "" }]);
    };

    const removePassenger = (idx) => {
        setPassengers((prev) => prev.filter((_, i) => i !== idx));
    };


    const savePassengers = async () => {
        if (passengers[0].firstName == "" || passengers[0].lastName == "") {
            setTostMessage({
                messageType: 'error',
                message: 'Add atleast one passenger'
            })
            return;
        }

        const formData = new FormData();
        formData.append('booking_reference', pageData?.booking_reference);
        formData.append('passengers', JSON.stringify(passengers));
        
        setButtonLoading(true)
        try {
            const response = await axios.post(base_url + '/my-flights/save_charter_passengers.php', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                },
            });
            if (response.data.status) {
                setTostMessage({
                    messageType: 'success',
                    message: response.data.message
                })
            } else {
                setTostMessage({
                    messageType: 'error',
                    message: response.data.message
                })
            }
            setButtonLoading(false)
        } catch (error) {
            setButtonLoading(false)
            setTostMessage({
                messageType: 'error',
                message: 'Network error'
            })
        }
    }

    return(
        <div className="w-full h-full">
            <TopBar />
            {loading && (
                <div className="flex items-center justify-center h-full w-[-webkit-fill-available] z-[99] fixed">
                    <ClockLoader
                        color={'#d8b05a'}
                        loading={true}
                        size={40}
                        aria-label="Loading Spinner"
                        data-testid="loader"
                    />
                </div>
            )}
            <div className="w-full p-4 sm:p-6">
                <div>
                    <div className="flex items-center gap-3 mb-2">
                        <div className="text-xl text-white/90">
                            <p className="font-semibold">
                                Flight Details
                            </p>
                        </div>
                    </div>
                    {payment_status == "cancelled" ? (
                        <>
                            <div className="flex items-center justify-center p-6">
                                {/* soft warm glow behind */}
                                <div className="relative w-full max-w-2xl">
                                    <div className="pointer-events-none absolute inset-0 -z-10 bg-[radial-gradient(60%_70%_at_50%_10%,rgba(216,176,90,0.18),transparent_60%)]" />
                                    <div className="pointer-events-none absolute inset-0 -z-10 bg-[radial-gradient(70%_80%_at_50%_80%,rgba(255,255,255,0.06),transparent_60%)]" />

                                    <div className="text-center">
                                    {/* icon badge */}
                                    <div className="mx-auto grid h-[10em] w-[10em] place-items-center rounded-full border border-[#d8b05a]/10 bg-[#d8b05a]/5 shadow-[0_15px_50px_rgba(216,176,90,0.08)]">
                                        <div className="grid place-items-center">
                                        <div className="">
                                            <BiSolidErrorAlt size={40} className="text-[#d8b05a]" />
                                        </div>

                                        <div className="mt-6 flex items-center justify-center gap-2">
                                            <span className="h-2 w-2 rounded-full bg-[#d8b05a]/50" />
                                            <span className="h-2 w-2 rounded-full bg-[#d8b05a]/80" />
                                            <span className="h-2 w-2 rounded-full bg-[#d8b05a]/50" />
                                        </div>
                                        </div>
                                    </div>

                                    <h2 className="mt-10 text-3xl sm:text-4xl font-semibold text-white/90 leading-tight">
                                        Booking Unsuccessful
                                    </h2>   

                                    <p className="mx-auto mt-5 max-w-xl text-sm sm:text-base leading-7 text-white/40">
                                        We are unable to verify your payment at this time.<br/>
                                        If this was an issue with your bank or our payment partners, please reach out to us for alternative means of payment. 
                                    </p>

                                    <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
                                        <button
                                        type="button"
                                        className={[
                                            "w-full sm:w-auto inline-flex items-center justify-center gap-2",
                                            "rounded-xl bg-[#d8b05a] px-6 py-3.5",
                                            "text-sm font-semibold text-black",
                                            "hover:brightness-110 active:brightness-95 transition",
                                            "focus:outline-none focus:ring-4 focus:ring-[#d8b05a]/20",
                                            "shadow-[0_10px_30px_rgba(216,176,90,0.18)]",
                                        ].join(" ")}
                                        >
                                        <FaWhatsapp className="h-5 w-5" />
                                        Chat on Whatsapp
                                        </button>

                                        <button
                                        type="button"
                                        onClick={() => window.open('mailto:info@roscroftjets.com')}
                                        className={[
                                            "w-full sm:w-auto inline-flex items-center justify-center gap-2",
                                            "rounded-xl border border-[#d8b05a]/35 bg-white/5 px-6 py-3.5",
                                            "text-sm font-semibold text-[#d8b05a]",
                                            "hover:bg-[#d8b05a]/10 transition",
                                            "focus:outline-none focus:ring-4 focus:ring-[#d8b05a]/15",
                                        ].join(" ")}
                                        >
                                        <MdEmail className="h-5 w-5" />
                                        Send Email
                                        </button>
                                    </div>                               
                                    </div>
                                </div>
                            </div>
                        </>
                    ) : (
                        <div className="mt-5 mx-auto w-full max-w-6xl">
                            {(payment_status == "success" || payment_status == "successful") && 
                            <div className="bg-[#00b47a]/10 w-full border border-1 border-[#00b47a]/70 rounded-xl p-4 mb-3">
                                <p className="text-lg text-[#00b47a] font-semibold">Booking Successful</p>
                                <p className="text-md text-[#ffffff]/90">Great! Check your email address for your booking confirmation.</p>
                            </div>
                            }
                            <div className="relative overflow-hidden rounded-2xl border border-white/10 bg-[#2E281F]/40 p-5 sm:p-6">
                                <div className="relative flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
                                {/* Left */}
                                <div className="min-w-0">
                                    <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
                                    <h2 className="text-3xl sm:text-4xl font-semibold text-white/90">
                                        PNR:{" "}
                                        <span className="font-medium">{booking_reference}</span>
                                    </h2>

                                    <span className="rounded-full border border-[#d8b05a]/25 bg-[#d8b05a]/10 px-4 py-1 text-xs font-semibold tracking-[0.22em] text-[#d8b05a]">
                                        {pageData?.status}
                                    </span>
                                    </div>

                                    <div className="mt-3 flex flex-wrap items-center gap-x-2 gap-y-1 text-base text-white/50">
                                    <span>{'Date:'}{' '}{pageData?.booking_time}</span>
                                    <span className="text-white/30">•</span>
                                    {(type == "CHARTERED" && (pageData?.status == "QUOTED" || pageData?.status == "APPROVED")) &&
                                    <button
                                        type="button"
                                        onClick={() => window.open(pageData?.quote?.invoice_file)}
                                        className="font-semibold text-[#d8b05a]/80 hover:underline"
                                    >
                                        View Invoice
                                    </button>
                                    }
                                    </div>
                                </div>

                                {/* Right actions */}
                                <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-end">
                                    {(pageData?.status == "APPROVED" || pageData?.status == "QUOTED") &&
                                    <button
                                    type="button"
                                    onClick={() => window.open(pageData?.boarding_pass)}
                                    className={[
                                        "inline-flex w-full sm:w-auto items-center justify-center gap-3",
                                        "h-12 rounded-xl px-6",
                                        "bg-[#d8b05a] text-black",
                                        "text-sm font-semibold",
                                        "hover:brightness-110 active:brightness-95 transition",
                                        "focus:outline-none focus:ring-4 focus:ring-[#d8b05a]/20",
                                        "shadow-[0_5px_30px_rgba(216,176,90,0.20)]",
                                    ].join(" ")}
                                    >
                                    <Icon name="download" className="text-black" />
                                    {type == "SHARED" ? 'Download Charter Agreement' : 'Download Charter Agreement'}
                                    </button>
                                    }
                                </div>
                                </div>
                            </div>
                            <div className="mt-7 grid grid-cols-1 gap-6 xl:grid-cols-[2.1fr_1fr]">
                                {/* LEFT: Next Upcoming Flight */}
                                <div>
                                    <div className="mx-auto w-full max-w-5xl space-y-6">
                                        {/* ===== Flight Itinerary ===== */}
                                        <SectionTitle icon="plane-depart" title="Flight Itinerary" />
            
                                        <div className="relative overflow-hidden rounded-2xl border border-white/10 bg-[#2E281F]">
            
                                            <div className="relative">
                                                {/* Header row */}
                                                <div className="flex flex-col gap-4 border-b border-white/10 p-5 sm:flex-row sm:items-center sm:justify-between">
                                                <div className="flex items-center gap-4">
                                                    <div className="grid h-12 w-12 place-items-center rounded-xl border border-white/10 bg-[#1a2a44]/40 text-[#d8b05a]">
                                                    <Icon name="badge" />
                                                    </div>
            
                                                    <div className="min-w-0">
                                                    <div className="truncate text-base font-semibold text-white/90">
                                                        Roscroft Jets — {pageData?.flight_no}
                                                    </div>
                                                    <div className="mt-1 text-xs tracking-wide text-white/40">
                                                        {pageData?.aircraft_name} • SHARED FLIGHT
                                                    </div>
                                                    </div>
                                                </div>
                                                {type == "SHARED" ?
                                                <div className="sm:text-right">
                                                    <div className="text-[11px] tracking-[0.28em] text-white/40">
                                                    DURATION
                                                    </div>
                                                    <div className="mt-1 text-lg font-semibold text-white/90">
                                                    {pageData?.duration}
                                                    </div>
                                                </div>
                                                :
                                                <div className="sm:text-right">
                                                    <div className="text-[11px] tracking-[0.28em] text-white/40">
                                                    TYPE
                                                    </div>
                                                    <div className="mt-1 text-lg font-semibold text-white/90">
                                                    {pageData?.trip_type}
                                                    </div>
                                                </div>
                                                }
                                                </div>
                                                {type == "SHARED" ?
                                                <div className="p-5 sm:p-6">
                                                    <div className="relative">
                                                        {pageData?.flight_itenary?.map((item, index) => 
                                                        <div className="flex gap-x-3 w-full relative pb-10">
                                                            <div className="">
                                                                <div className={`grid h-12 w-12 place-items-center rounded-full ${index !== 0 ? 'border-[#d8b05a]/30 bg-[#0b0b0b] text-[#d8b05a]' : 'bg-[#d8b05a] text-black'} shadow-[0_20px_60px_rgba(216,176,90,0.18)]`}>
                                                                {index == 0 && <Icon name="plane-depart" className="h-6 w-6" />}
                                                                {(index == pageData?.flight_itenary.length-1) && <Icon name="plane-arrive" className="h-6 w-6" />}
                                                                {(index > 0 && index !== pageData?.flight_itenary.length-1) && <Icon name="plane-cruise" className="h-6 w-6" />}
                                                                </div>
                                                            </div>
                
                                                            <div className="w-full flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
                                                                <div>
                                                                <div className="text-3xl font-semibold text-[#d8b05a]">
                                                                    {item?.departure_time}
                                                                </div>
                                                                <div className="mt-1 text-xl font-semibold text-white/90">
                                                                    {item?.airport_city} ({item?.airport_iata})
                                                                </div>
                                                                <div className="mt-1 text-sm text-white/40">
                                                                    {item?.airport_name}
                                                                </div>
                                                                </div>
                                                                <div className="text-sm text-white/40 sm:text-right">
                                                                {item?.departure_date}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        )}
                                                    </div>
                                                </div>
                                                : 
                                                <div className="p-5 sm:p-6">
                                                    <div className="relative">
                                                        {pageData?.flight_itenary?.map((item, index) => 
                                                        <div className="flex gap-x-3 w-full relative pb-10">
                                                            <div className="">
                                                                <div className={`grid h-12 w-12 place-items-center rounded-full ${index !== 0 ? 'border-[#d8b05a]/30 bg-[#0b0b0b] text-[#d8b05a]' : 'bg-[#d8b05a] text-black'} shadow-[0_20px_60px_rgba(216,176,90,0.18)]`}>
                                                                {index == 0 && <Icon name="plane-depart" className="h-6 w-6" />}
                                                                {(index == pageData?.flight_itenary.length-1 && index !== 0) && <Icon name="plane-arrive" className="h-6 w-6" />}
                                                                {(index > 0 && index !== pageData?.flight_itenary.length-1) && <Icon name="plane-cruise" className="h-6 w-6" />}
                                                                </div>
                                                            </div>
                
                                                            <div className="w-full flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
                                                                <div>
                                                                    <div className="text-2xl font-semibold text-[#d8b05a]">
                                                                        {item?.origin_airport_city} ({item?.origin_airport_iata})
                                                                    </div>
                                                                    <div className="mt-1 text-lg font-regular text-white/90">
                                                                        {item?.departure_time}
                                                                    </div>
                                                                    <div className="mt-1 text-sm text-white/40">
                                                                        {item?.origin_airport_name}
                                                                    </div>
                                                                </div>
                                                                <div>
                                                                    <div className="text-2xl font-semibold text-[#d8b05a] text-end">
                                                                        {item?.arrival_airport_city} ({item?.arrival_airport_iata})
                                                                    </div>
                                                                    <div className="mt-1 text-sm text-white/40 text-end">
                                                                        {item?.arrival_airport_name}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        )}
                                                    </div>
                                                </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mx-auto w-full max-w-5xl space-y-6 mt-6">
                                        <SectionTitle icon="users" title="Flight Manifest" />
                                        <div className="relative overflow-hidden rounded-2xl border border-white/10 bg-[#2E281F] p-6">
                                            <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-end">
                                                <button
                                                    type="button"
                                                    onClick={addPassenger}
                                                    className={[
                                                    "inline-flex items-center justify-center gap-2 rounded-xl",
                                                    "border border-[#d8b05a]/30 bg-white/5 px-4 py-2.5",
                                                    "text-sm font-semibold text-[#d8b05a]",
                                                    "hover:bg-[#d8b05a]/10 transition",
                                                    "focus:outline-none focus:ring-4 focus:ring-[#d8b05a]/15",
                                                    "self-start",
                                                    ].join(" ")}
                                                >
                                                    <Icon name="plus" className="h-4 w-4" />
                                                    Add Passenger
                                                </button>
                                            </div>
                                            {/* Passenger cards */}
                                            <div className="mt-6 space-y-6">
                                            {passengers?.map((p, idx) => (
                                                <div
                                                key={idx}
                                                className="relative overflow-hidden rounded-2xl border border-white/10 bg-white/5"
                                                >
                                                <div className="relative">
                                                    {/* Card header */}
                                                    <div className="flex items-center justify-between border-b border-white/10 px-5 py-4">
                                                    <div className="text-[11px] font-semibold tracking-[0.28em] text-[#d8b05a]/80">
                                                        PASSENGER {idx + 1}
                                                    </div>
                            
                                                    {passengers.length > 1 && (
                                                        <button
                                                        type="button"
                                                        onClick={() => removePassenger(idx)}
                                                        className="rounded-lg p-2 text-white/40 hover:text-white/70"
                                                        aria-label="Remove passenger"
                                                        >
                                                        <Icon name="trash" />
                                                        </button>
                                                    )}
                                                    </div>
                            
                                                    {/* Form */}
                                                    <div className="px-5 py-5">
                                                        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-4">
                                                            <TextInput
                                                            label="First Name"
                                                            placeholder="e.g. Alexander"
                                                            value={p.firstName}
                                                            onChange={(v) => updatePassenger(idx, { firstName: v })}
                                                            />
                                                            <TextInput
                                                            label="Last Name"
                                                            placeholder="e.g. Rothschild"
                                                            value={p.lastName}
                                                            onChange={(v) => updatePassenger(idx, { lastName: v })}
                                                            />
                                                            <DateInput
                                                            label="Date of Birth"
                                                            value={p.dob}
                                                            onChange={(v) => updatePassenger(idx, { dob: v })}
                                                            />
                                                            <TextInput
                                                            label="Passport Number"
                                                            placeholder="A12345678"
                                                            value={p.passport}
                                                            onChange={(v) => updatePassenger(idx, { passport: v })}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                </div>
                                            ))}
                                            <div className="mt-5">
                                                <div className="flex flex-col gap-5 lg:flex-row lg:items-center lg:justify-end">
                                                    <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-end">
                                                        <button
                                                            type="button"
                                                            onClick={() => savePassengers()}
                                                            className={[
                                                            "h-12 rounded-xl px-6 text-sm font-semibold",
                                                            "bg-[#d8b05a] text-black",
                                                            "hover:brightness-110 active:brightness-95 transition",
                                                            "focus:outline-none focus:ring-4 focus:ring-[#d8b05a]/20",
                                                            "inline-flex items-center justify-center gap-3",
                                                            ].join(" ")}
                                                        >
                                                            Save
                                                            <Icon name="arrow" className="h-5 w-5" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mx-auto w-full max-w-5xl space-y-6 mt-6">
                                        <SectionTitle icon="users" title="Contact Person" />
                                        <div className="relative overflow-hidden rounded-2xl border border-white/10 bg-[#2E281F]">
                                            {/* Table header */}
                                            <div className="relative border-b border-white/10 px-5 py-4">
                                                <div className="grid grid-cols-12 gap-3 text-[11px] tracking-[0.28em] text-white/50">
                                                <div className="col-span-12 sm:col-span-5">NAME</div>
                                                <div className="hidden sm:block sm:col-span-3">PHONE.</div>
                                                <div className="hidden sm:block sm:col-span-2">EMAIL</div>
                                                </div>
                                            </div>
            
                                            <div className="relative divide-y divide-white/10">
                                                <div className="px-5 py-5">
                                                    <div className="grid grid-cols-12 gap-3 items-center">
                                                        <div className="col-span-12 sm:col-span-5 min-w-0">
                                                            <div className="truncate text-base font-semibold text-white/90">
                                                                {pageData?.contact_name}
                                                            </div>
                                                        </div>
                                                        <div className="col-span-6 sm:col-span-3 text-sm text-white/80 sm:text-left text-right">
                                                            {pageData?.contact_email}
                                                        </div>
                                                        <div className="col-span-12 sm:col-span-2 text-sm text-white/80 sm:text-left text-right">
                                                            {pageData?.contact_phone}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {(pageData?.notes != "" && type == "CHARTERED") && 
                                    <div className="mx-auto w-full max-w-5xl space-y-6 mt-6">
                                        <SectionTitle icon="users" title="Booking Note" />
                                        <div className="relative overflow-hidden rounded-2xl border border-white/10 bg-[#2E281F]">
                                            {/* Table header */}
                                            <div className="relative border-b border-white/10 px-5 py-4">
                                                <div className="grid grid-cols-12 gap-3 text-[11px] tracking-[0.28em] text-white/50">
                                                    <div className="col-span-12 sm:col-span-5">MESSAGE</div>
                                                </div>
                                            </div>
            
                                            <div className="relative divide-y divide-white/10">
                                                <div className="px-5 py-5">
                                                    <div className="grid grid-cols-12 gap-3 items-center">
                                                        <div className="col-span-12 sm:col-span-5 min-w-0">
                                                            <div className="truncate text-base font-semibold text-white/90">
                                                                {pageData?.notes}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    }
                                </div>
                                {/* RIGHT: Loyalty stats */}
                                <div>
                                    <div className="mx-auto w-full max-w-xl space-y-6">
                                        <CardShell>
                                        <div className="p-6 sm:p-8">
                                            <h2 className="text-xl font-semibold text-white/90">
                                            Manage Booking
                                            </h2>

                                            <div className="mt-6">
                                                <div className="h-px w-full bg-white/10" />
                                            </div>

                                            <div className="mt-6 space-y-4">
                                                <button
                                                    type="button"
                                                    onClick={() => setTostMessage({ messageType: 'warning', message: 'Flight change not available' })}
                                                    className={[
                                                    "w-full rounded-xl border border-[#d8b05a]/20 bg-white/5 px-3 py-3",
                                                    "flex items-center justify-between gap-4",
                                                    "hover:bg-white/8 transition",
                                                    "focus:outline-none focus:ring-4 focus:ring-[#d8b05a]/10",
                                                    ].join(" ")}
                                                >
                                                    <div className="flex items-center gap-4 min-w-0">
                                                        <div className="text-[#d8b05a]">
                                                            <Icon name={'calendarEdit'} />
                                                        </div>
                                                        <div className="truncate text-lg font-medium text-white/90">{'Request Change'}</div>
                                                    </div>

                                                    <div className="text-white/40">
                                                        <Icon name="chevR" />
                                                    </div>
                                                </button>
                                            </div>

                                            <div className="mt-7">
                                                <div className="h-px w-full bg-white/10" />
                                            </div>

                                            <button
                                            type="button"
                                            onClick={() => setTostMessage({ messageType: 'warning', message: 'Please reach out to our support team to fulfill this request' })}
                                            className="mt-7 inline-flex items-center gap-4 text-md font-medium text-red-400 hover:text-red-300 transition"
                                            >
                                            <span className="grid h-10 w-10 place-items-center rounded-full bg-red-500/20 text-red-400">
                                                <Icon name="x" className="h-6 w-6" />
                                            </span>
                                            Cancel Booking
                                            </button>
                                        </div>
                                        </CardShell>

                                        {/* Payment Summary */}
                                        <CardShell>
                                        {pageData?.status == "APPROVED" ?     
                                        <div className="p-6 sm:p-8">
                                            <h2 className="text-xl font-semibold text-white/90">
                                            Payment Summary
                                            </h2>

                                            <div className="mt-8 space-y-6">
                                                <div className="flex items-center justify-between gap-4">
                                                    <div className="text-lg text-white/40">{'Booking Amount'}</div>
                                                    <div className="text-lg font-medium text-white/80">{pageData?.booking_currency}{pageData?.booking_amount}</div>
                                                </div>
                                            </div>

                                            <div className="mt-7">
                                                <div className="h-px w-full bg-white/10" />
                                            </div>

                                            <div className="mt-7 flex items-end justify-between gap-6">
                                            <div className="text-2xl font-medium text-[#d8b05a]/90">
                                                Total Paid
                                            </div>
                                            <div className="text-3xl font-semibold text-[#d8b05a]">
                                                {pageData?.booking_currency}{pageData?.booking_amount}
                                            </div>
                                            </div>
                                        </div>
                                        : 
                                            (
                                                pageData?.status !== "QUOTED" ?
                                                <div className="p-6 sm:p-8">
                                                    <h2 className="text-xl font-semibold text-white/90">
                                                    Proceed to Pay
                                                    </h2>

                                                    <div className="mt-8 space-y-6">
                                                        <div className="flex items-center justify-between gap-4">
                                                            <div className="text-lg text-white/40">{'Booking Amount'}</div>
                                                            <div className="text-lg font-medium text-white/80">{'Awaiting Quote'}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                : 
                                                <div className="p-6 sm:p-8">
                                                    <h2 className="text-xl font-semibold text-white/90">
                                                    Proceed to Pay
                                                    </h2>

                                                    <div className="mt-8 space-y-6">
                                                        <div className="flex items-center justify-between gap-4">
                                                            <div className="text-lg text-white/40">{'Booking Amount'}</div>
                                                            <div className="text-lg font-medium text-white/80">{pageData?.quote?.quote_currency}{pageData?.quote?.quote_amount}</div>
                                                        </div>
                                                    </div>

                                                    <div className="mt-7">
                                                        <div className="h-px w-full bg-white/10" />
                                                    </div>

                                                    <div className="mt-7 flex items-end justify-between gap-6">
                                                        <button
                                                            type="button"
                                                            onClick={() => buttonLoading ? null : PayNGN(pageData?.booking_reference)}
                                                            className={[
                                                            "mt-8 w-full rounded-2xl bg-[#d8b05a] px-6 h-[50px]",
                                                            "text-md font-extrabold tracking-wide text-[#0b0b0b]",
                                                            "hover:brightness-110 active:brightness-95 transition",
                                                            "focus:outline-none focus:ring-4 focus:ring-[#d8b05a]/20",
                                                            "shadow-[0_18px_60px_rgba(216,176,90,0.25)]",
                                                            "inline-flex items-center justify-center gap-4",
                                                            ].join(" ")}
                                                        >   
                                                            {buttonLoading ? <BarLoader 
                                                                color={'#ffffff'}
                                                                loading={true}
                                                                size={7}
                                                                aria-label="Loading Spinner"
                                                                data-testid="loader"
                                                            /> : 
                                                            <>
                                                                PAY in NAIRA
                                                                <span className="text-[#0b0b0b]">
                                                                <Icon name="lock" className="h-6 w-6" />
                                                                </span>
                                                            </>
                                                            }
                                                        </button>
                                                    </div>
                                                </div>
                                            )
                                        }
                                        </CardShell>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}